(function () {
    'use strict';
    angular.module('app').controller('approve', approve);
    approve.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', 'SelectionCommand_WorkflowService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'approvalAuthService'];
    function approve($location, scope, $rootScope, gridDataService, SelectionCommand_WorkflowService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, approvalAuthService) {

        // =====================================
        // On Load.
        // =====================================

        // Initialize.
        // PL-OBS? scope.approveDialogShown = false;
        scope.ACN_APPROVE = 120;
        scope.ACN_REJECT = 129;
        scope.xyz = { bReadyForOK: false, comment: "", bOneCanCreateVersion: false, bCreateVersion: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        // =====================================
        // On Load. Assign To.
        // =====================================
        // Set the combo to 'building list'.
        scope.qualifiedUsersArrayLoading = function () {
            // If already on the 'building list', just leave it.
            if (scope.xyz.selectedUserItem != scope.qualifiedUsersBuildingList) {
                // Clear the array.
                scope.qualifiedUsersArray = [];
                // Add 'building list' to the array.
                scope.qualifiedUsersArray.push(scope.qualifiedUsersBuildingList);
                // Select 'building list' in the combo.
                scope.xyz.selectedUserItem = scope.qualifiedUsersBuildingList;
                // We are waiting for the items.
                scope.xyz.gettingUserList = true;
            }
        };
        // Load items into the combo. May be null.
        scope.qualifiedUsersArrayLoad = function (users) {
            // Clear the array.
            scope.qualifiedUsersArray = [];
            // Add 'pick one'.
            scope.qualifiedUsersArray.push(scope.qualifiedUsersPickOne);
            // Select 'pick one'.
            scope.xyz.selectedUserItem = scope.qualifiedUsersPickOne;
            // Add ''.
            scope.qualifiedUsersArray.push(scope.qualifiedUsersBlank);
            // If there are items, ...
            if (users != null) {
                // Walk the items, ...
                angular.forEach(users, function (name, id) {
                    // Add the item to the array.
                    scope.qualifiedUsersArray.push({ id: id, name: name })
                });
            }
            // We are done getting the items.
            scope.xyz.gettingUserList = false;
        }
        // Create a 'building list' item.
        scope.qualifiedUsersBuildingList = { id: 'building_list', name: "- " + loginService.resourceStrings["COMBO_BOX_BUILDING_LIST"] + " -" };
        // Create a 'pick one' item.
        scope.qualifiedUsersPickOne = { id: 'pick_one', name: "- " + loginService.resourceStrings["COMBO_BOX_PICK_ONE"] + " -" };
        // Create a '' item.
        scope.qualifiedUsersBlank = { id: '', name: '' };
        // Initailize to the 'building list' state.
        scope.qualifiedUsersArrayLoading();

        // =====================================
        //
        // =====================================  

        //
        // On comment change.
        //
        scope.onCommentChanged = function () {
            
            var commentForGrid = scope.xyz.comment;
            // EDGE-EMPTY     
            if (scope.xyz.comment.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.comment = '\u00A0';
                    commentForGrid = '\u00A0';
                }
            }

            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.isSelected) {
                    gridItem.comment = commentForGrid; // scope.xyz.comment;
                    gridItem.selectionItem.commandParams.eWorkflowComment = scope.xyz.comment; // *****
                }
            }
            // Do Enables.
            scope.doEnables();
        };

        //
        // On user change.
        //
        scope.selectedUserChanged = function () {
            // If nothing selected, then return.
            if (scope.xyz.selectedUserItem == null)
                return;
            // If user selected 'pick one', then return.
            if (scope.xyz.selectedUserItem == scope.qualifiedUsersPickOne)
                return;


            var nameForGrid = scope.xyz.selectedUserItem.name;
            // EDGE-EMPTY
            if (scope.xyz.selectedUserItem.name.length < 1) {
                var browserInfo = navigator.userAgent;
                var bIsEdge = browserInfo.indexOf('Edge/') != -1;
                if (bIsEdge) {
                    // scope.xyz.selectedUserItem.name = '\u00A0';
                    nameForGrid = '\u00A0';
                }
            }

            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.isSelected) {
                    gridItem.assignToId = scope.xyz.selectedUserItem.id;
                    gridItem.assignTo = nameForGrid; // scope.xyz.selectedUserItem.name;
                    gridItem.selectionItem.commandParams.eAssignToUserId = scope.xyz.selectedUserItem.id; // *****
                }
            }
            // Do Enables.
            scope.doEnables();
        };

        //
        // On check/uncheck of the Create Version checkbox.
        //
        scope.createVersionCheckChanged = function () {
            // Walk the grid's selected items.
            var len = scope.gridOptions.data.length;
            for (var i = 0; i < len; i++) {
                // Get this selected item.
                var gridItem = scope.gridOptions.data[i];
                if (gridItem.isSelected && gridItem.bCanCreateVersion == 'T') {
                    gridItem.bCreateVersion = scope.xyz.bCreateVersion ? "T" : "F";
                    gridItem.selectionItem.commandParams.ebMakeRevision = scope.xyz.bCreateVersion; // *****
                }
            }
            // Do Enables.
            scope.doEnables();
        };

        //
        // Enables.
        //
        scope.doEnables = function () {
            // Do all steps that require a comment, have one?
            var bAllHaveRequiredComment = true;

            var bOneReq = false;
            var bOneCan = false;

            // ***** For label updates, only consider selected.
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                if (gridItem.bCommentRequired == 'T') {
                    bOneReq = true;
                }
                if (gridItem.bCanCreateVersion == 'T') {
                    bOneCan = true;
                }
            });

            // ***** For enable logic, consider all rows.
            angular.forEach(scope.gridOptions.data, function (gridItem) {
                // See if this row requires and comment and does not have one.
                if (gridItem.bCommentRequired == 'T' && gridItem.comment.length < 1)
                    bAllHaveRequiredComment = false;
            });

            // Update the comment label.
            if (bOneReq)
                scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT_REQUIRED"]; // "Enter Comment (required)";
            else
                scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT_OPTIONAL"]; // "Enter Comment (optional)";

            // Update the create version label and checkbox.
            if (bOneCan) {
                scope.xyz.bOneCanCreateVersion = true;
                scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION"]; // "Create Version";
            }
            else {
                scope.xyz.bOneCanCreateVersion = false;
                scope.xyz.createVersion = false;
                scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION_NOT_APPLICABLE"]; // "Create Version N/A";
            }

            // Handle enabling OK.
            scope.xyz.bReadyForOK = bAllHaveRequiredComment;
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function () {

            // Always set all items to not selected.
            angular.forEach(scope.gridOptions.data, function (item) {
                item.isSelected = false;
            });

            var bAllAreOnLastStep = true;

            // Get the selected items.
            var items = [];
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (item) {
                item.isSelected = true;
                items.push(item.selectionItem);

                // If on last step, then one of these will be true.
                if (item.bWillCreateVersion == 'F' && item.bCanCreateVersion == 'F')
                    bAllAreOnLastStep = false;
            });

            if (bAllAreOnLastStep)
                scope.xyz.bHideAssign = true;
            else {
                scope.xyz.bHideAssign = false;
           
                // Build the SL with mode and order.
                var slx = { mode: 0, order: 0, list: items };

                // ============================
                // Select Item. Assign To.
                // ===========================+
                // Add users to the combo.
                scope.qualifiedUsersArrayLoading();
                if (items.length < 1) {
                    scope.qualifiedUsersArrayLoad();
                }
                else {
                    SelectionCommand_WorkflowService.GetUserListForAssign(slx, scope.mode).then(function (response) {
                        scope.qualifiedUsersArrayLoad(response.data);
                    }, function () {
                        scope.qualifiedUsersArrayLoad();
                    });
                }
            }

            // Do Enables.
            scope.doEnables();
        };

        // On click of the Approve button.
        scope.onApproveButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_APPROVE;
            scope.xyz = { bReadyForOK: false, comment: "", selectedUserItem: {}, bHideAssign: true, bOneCanCreateVersion: false, bCreateVersion: false };

            // dialog config
            scope.heading = loginService.resourceStrings["APPROVE"]; // "Approve";
            scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT"]; // "Enter Comment";
            scope.assignToLabel = loginService.resourceStrings["ASSIGN_TO"]; // "Assign To";
            scope.createVersionLabel = loginService.resourceStrings["CREATE_VERSION"]; // "Create Version";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_APPROVE"]; // "Files to Approve";
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // Get options and add to grid.
            scope.gridOptions.data = [];
            SelectionCommand_WorkflowService.GetApproveOptionsList(slx, scope.mode).then(function (response) {
                // It is OK to keep this seperate because the response item is different than the selection item.
                var bCommentRequired = [];
                var bWillCreateVersion = [];
                var bCanCreateVersion = [];
                angular.forEach(response.data, function (item, key) {
                    var fileId = key;
                    bCommentRequired[fileId] = item.bCommentRequired;
                    bWillCreateVersion[fileId] = item.bWillCreateVersion;
                    bCanCreateVersion[fileId] = item.bCanCreateVersion;
                });

                // For each selection item, add a row to the grid.
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, library: item.detailedInfo.libName,
                        activeWorkflowName: item.detailedInfo.activeWorkflowName, activeStepName: item.detailedInfo.activeStepName,
                        bCommentRequired: bCommentRequired[item.fileId] ? 'T' : 'F', comment: "",
                        assignToId: "", assignTo: "",
                        bWillCreateVersion: bWillCreateVersion[item.fileId] ? 'T' : 'F',
                        bCanCreateVersion: bCanCreateVersion[item.fileId] ? 'T' : 'F', bCreateVersion: 'F'
                    });
                    index++;
                });

                // Enables.
                $timeout(function () {
                    refreshGrid();
                    scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);

            });
        };

        // On click of the Reject button.
        scope.onRejectButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.mode = scope.ACN_REJECT;
            scope.xyz = { bReadyForOK: false, comment: "", selectedUserItem: {}, bOneCanCreateVersion: false, bCreateVersion: false };

            // dialog config
            scope.heading = loginService.resourceStrings["REJECT"]; // "Reject";
            scope.enterCommentLabel = loginService.resourceStrings["ENTER_COMMENT"]; // "Enter Comment";
            scope.assignToLabel = loginService.resourceStrings["ASSIGN_TO"]; // "Assign To";
            scope.filesLabel = loginService.resourceStrings["FILES_TO_REJECT"]; // "Files to Reject";
            scope.createVersionLabel = ""; // N/A for Reject
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // Get options and add to grid.
            scope.gridOptions.data = [];
            SelectionCommand_WorkflowService.GetApproveOptionsList(slx, scope.mode).then(function (response) {
                // It is OK to keep this seperate because the response item is different than the selection item.
                var bCommentRequired = [];
                var bWillCreateVersion = [];
                var bCanCreateVersion = [];
                angular.forEach(response.data, function (item, key) {
                    var fileId = key;
                    bCommentRequired[fileId] = item.bCommentRequired;
                    bWillCreateVersion[fileId] = item.bWillCreateVersion;
                    bCanCreateVersion[fileId] = item.bCanCreateVersion;
                });

                // For each selection item, add a row to the grid.
                var index = 0;
                angular.forEach(scope.slx.list, function (item) {
                    scope.gridOptions.data.push({
                        index: index,
                        selectionItem: item,
                        isSelected: true,
                        name: item.filename, library: item.detailedInfo.libName,
                        activeWorkflowName: item.detailedInfo.activeWorkflowName, activeStepName: item.detailedInfo.activeStepName,
                        bCommentRequired: bCommentRequired[item.fileId] ? 'T' : 'F', comment: "",
                        assignToId: "", assignTo: "",
                        bWillCreateVersion: bWillCreateVersion[item.fileId] ? 'T' : 'F',
                        bCanCreateVersion: bCanCreateVersion[item.fileId] ? 'T' : 'F', bCreateVersion: 'F'
                    });
                    index++;
                });

                // Enables.
                $timeout(function () {
                    refreshGrid();
                    scope.gridApi.selection.selectAllRows();
                    $timeout(function () {
                        refreshGrid();
                    }, 2000);
                }, 500);
            });
        }

        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            var colActiveWorkflow = loginService.resourceStrings["SCHEMA_S_WFNAME"];
            var colActiveStep = loginService.resourceStrings["SCHEMA_S_STEPNAME"];
            var colComment = loginService.resourceStrings["COMMENT"];
            var colAssignTo = loginService.resourceStrings["ASSIGN_TO"];
            var colCreateVersion = loginService.resourceStrings["CREATE_VERSION"];
            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
            scope.gridOptions.columnDefs[2].name = colActiveWorkflow;
            scope.gridOptions.columnDefs[3].name = colActiveStep;
            scope.gridOptions.columnDefs[4].name = colComment;
            scope.gridOptions.columnDefs[5].name = colAssignTo;
            scope.gridOptions.columnDefs[6].name = colCreateVersion;
        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.onApproveDialogOK = function () {
            //check approval auth
            approvalAuthService.handleApprovalAuth(scope.slx).then(function(resp) {
                if (resp == 'cancel') {
                    return;
                }
                scope.xyz.processing = true;
                if (scope.mode == scope.ACN_APPROVE) {
                    // Execute.
                    //console.log(scope.slx);
                    //check required fields
                    commandService.handleRequiredFields(scope.slx, 120).then(function (slx) {
    
                        if (slx.list.length == 0) {
                            $mdDialog.hide();
                            scope.xyz.processing = false;
                            return;
                        }
    
                        SelectionCommand_WorkflowService.Approve(slx).then(function (response) {
                            // Handle errors.
                            var atLeastOneError = false;
                            var selectionCommandResults = response.data;
                            var slx = selectionCommandResults.slx;
    
                            commandService.updateRequiredFields(slx.list).then(function () {
                                angular.forEach(slx.list, function (item) {
                                    if (atLeastOneError == false) {
                                        if (item.ec != 0) {
                                            atLeastOneError = true;
                                            if (atLeastOneError) {
                                                commandService.launchErrors({ slx: slx });
                                                //$rootScope.$broadcast('showErrorList', { slx: response.data });
                                            }
                                        }
                                    }
                                });
                                
                                $timeout(function () {
                                    gridDataService.updateGridRecords(slx.list);
                                    //gridDataService.reloadGrid(); // $rootScope.$broadcast('grid:reload');
    
                                    editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                                    // Close dialog and refresh grid.
                                    $mdDialog.hide();
                                    scope.xyz.processing = false;
                                }, 300);
                            });
                        });
                    }, function () {
                        $mdDialog.hide();
                        scope.xyz.processing = false;
                    }); 
                }
                else {
                    // Execute.
                    SelectionCommand_WorkflowService.Reject(scope.slx).then(function (response) {
                        // Handle errors.
                        var atLeastOneError = false;
                        var selectionCommandResults = response.data;
                        var slx = selectionCommandResults.slx;
                        angular.forEach(slx.list, function (item) {
                            if (atLeastOneError == false) {
                                if (item.ec != 0) {
                                    atLeastOneError = true;
                                    if (atLeastOneError) {
                                        commandService.launchErrors({ slx: slx });
                                        //$rootScope.$broadcast('showErrorList', { slx: response.data });
                                    }
                                }
                            }
                        });
                        // Close dialog and refresh grid.
                        $mdDialog.hide();
                        scope.xyz.processing = false;
                        gridDataService.updateGridRecords(slx.list);
    
                        editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                    });
                }
            });
        };

        scope.onApproveDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.approveDialogClosed = function () {

        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);



            //after the grid has been initialized
            switch (command) {
                case "approve":
                    scope.onApproveButtonClicked(records);
                    break;
                case "reject":
                    scope.onRejectButtonClicked(records);
                    break;
            }
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'FileName', field: 'name', width: '12%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '12%', minWidth: '100' },
                { name: 'Active Workflow', field: 'activeWorkflowName', width: '15%', minWidth: '100' },
                { name: 'Active Step', field: 'activeStepName', width: '15%', minWidth: '100' },
                { name: 'Comment', field: 'comment', width: '15%', minWidth: '100' },
                { name: 'Assign To', field: 'assignTo', width: '15%', minWidth: '100' },
                { name: 'Create Version', field: 'bCreateVersion', width: '16%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
